"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function SecurityCommandCentreGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__security-command-centre-grey-outline__clip0_19506_5336)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M5.9 5.308c-.305.22-.565.491-.774.804l-.413-.387-.409-.384-2.188-2.054-.428-.401.767-.815.558.524 2.061 1.939.41.383.416.39zM8.282 15.083l-1.116.037-.015-.487-.09-2.806-.018-.566-.015-.576a2.8 2.8 0 001.116.022l.015.566.019.558.089 2.742.015.51zM13.536 2.71l-.372.362-2.255 2.18-.402.387-.41.394a2.947 2.947 0 00-.796-.78l.41-.399.405-.39 1.957-1.891.689-.666.774.804z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M10.507 5.639a3.552 3.552 0 00-2.865-1.447 3.555 3.555 0 00-3.561 3.56c0 1.76 1.28 3.223 2.962 3.51.193.03.394.048.599.048a3.557 3.557 0 003.557-3.557 3.55 3.55 0 00-.692-2.114zm-2.363 5.068a2.809 2.809 0 01-1.116-.022 2.997 2.997 0 01-1.901-4.573c.208-.313.468-.585.773-.804a2.963 2.963 0 011.742-.558 2.988 2.988 0 012.456 1.283c.342.488.543 1.08.543 1.72a3.003 3.003 0 01-2.497 2.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M10.909 5.252a4.082 4.082 0 00-.793-.789 4.084 4.084 0 00-2.474-.83c-.93 0-1.864.335-2.568.9-.294.232-.55.503-.77.808a4.094 4.094 0 00-.781 2.411 4.122 4.122 0 004.119 4.116 4.117 4.117 0 004.115-4.115c0-.938-.316-1.809-.848-2.501zm-3.267 5.5a2.8 2.8 0 01-.614-.067 2.997 2.997 0 01-1.902-4.573c.209-.313.47-.585.774-.804a2.963 2.963 0 011.742-.558 2.988 2.988 0 012.456 1.283c.342.488.543 1.08.543 1.72a3.003 3.003 0 01-3 2.999z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M14.101 1.665a.57.57 0 00-.424-.145C11.125 1.728 7.928.08 7.9.061a.575.575 0 00-.518 0C7.351.08 4.148 1.725 1.603 1.52a.576.576 0 00-.424.145.578.578 0 00-.179.413v7.368c0 1.041.346 2.031.997 2.861.514.659 2.08 2.333 5.44 3.654a.542.542 0 00.41 0c3.356-1.321 4.922-2.995 5.44-3.654.65-.83.993-1.82.993-2.861V2.078a.578.578 0 00-.179-.413zm-.937 7.78c0 .79-.26 1.541-.756 2.17-.416.536-1.61 1.812-4.141 2.958-.2.09-.41.179-.629.268a11.886 11.886 0 01-.487-.208c-2.627-1.158-3.855-2.475-4.276-3.018a3.462 3.462 0 01-.759-2.17v-6.79c.298-.004.596-.022.897-.06 1.994-.23 3.94-1.086 4.625-1.414.666.317 2.504 1.132 4.435 1.392.365.048.73.078 1.09.082v6.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M7.638 9.085a1.332 1.332 0 100-2.665 1.332 1.332 0 000 2.665z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__security-command-centre-grey-outline__clip0_19506_5336"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

SecurityCommandCentreGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
SecurityCommandCentreGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = SecurityCommandCentreGreyOutline;
exports["default"] = _default;